module.exports = __webpack_public_path__ + "static/media/leadBundle2.fd1b1f3e.svg";